import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Cart.css';
import { useNavigate } from 'react-router-dom';
import { mainImageURI, updateCart, deleteCart } from '../components/assets/constants/Urls/Url';
import axios from 'axios';
import useCart from '../hooks/cartCall';
import getCartSessionId from '../hooks/getCartSessionId';
import { FaTrashAlt } from 'react-icons/fa';
import { useTheme } from '../components/assets/context/ThemeContex';

const Cart = () => {
  const navigate = useNavigate();
  const { cartData, error, isLoading } = useCart();
  const [cartItem, setCartItem] = useState([]);
  const { theme } = useTheme();

  useEffect(() => {
    setCartItem(cartData);
  }, [cartData]);

  const onUpdateQuantity = async (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    try {
      const id = JSON.parse(localStorage.getItem("id"));
      if (id) {
        const res = await axios.put(`${updateCart}${itemId}`, { quantity: newQuantity });
        if (res.status === 200) {
          const updatedCart = cartItem.map((item) =>
            item.cart_id === itemId ? { ...item, quantity: newQuantity } : item
          );
          setCartItem(updatedCart);
        }
      } else {
        const cartId = getCartSessionId();
        const cart = JSON.parse(localStorage.getItem(cartId)) || [];
        const updatedCart = cart.map((item) => (
          item.cart_id === itemId ? { ...item, quantity: newQuantity } : item
        ));
        localStorage.setItem(cartId, JSON.stringify(updatedCart));
        setCartItem(updatedCart);
      }
    } catch (error) {}
  };

  const onDeleteItem = async (itemId) => {
    try {
      const id = JSON.parse(localStorage.getItem("id"));
      if (id) {
        const res = await axios.delete(`${deleteCart}${itemId}`);
        if (res.status === 200) {
          const updatedCart = cartItem.filter((item) => item.cart_id !== itemId);
          setCartItem(updatedCart);
        }
      } else {
        const cartId = getCartSessionId();
        const cart = JSON.parse(localStorage.getItem(cartId)) || [];
        const updatedCart = cart.filter((item) => item.cart_id !== itemId);
        localStorage.setItem(cartId, JSON.stringify(updatedCart));
        setCartItem(updatedCart);
      }
    } catch (error) {}
  };

  const calculateSubtotal = () => {
    return cartItem?.reduce((total, item) => total + item.price * item.quantity, 0) || 0;
  };

  const subtotal = calculateSubtotal();

  return (
    <div
      className="container mt-4"
      style={{
        background: "var(--background)",
        color: "var(--textMain)",
        minHeight: "100vh"
      }}
    >
      <div className="col">
        <h2 style={{ color: "var(--textHeading)" }}>Your Cart</h2>
        {isLoading ? (
          <div>Loading...</div>
        ) : error ? (
          <div>No item in cart</div>
        ) : cartItem && cartItem.length > 0 ? (
          cartItem.map((item) => (
            <div className="col-12 mb-3" key={item.id}>
              <div
                className="card d-flex flex-row flex-wrap position-relative"
                style={{
                  background: "var(--cardBackground)",
                  color: "var(--textMain)",
                  border: `1px solid var(--cardBorder)`
                }}
              >
                <picture>
                  <source srcSet={`${mainImageURI}${(String(item.product_id + "_" + 0)).replace(/\.(jpg|jpeg|png)$/, '.webp')}/${item.product_id}`} type="image/webp" />
                  <img
                    src={`${mainImageURI}${String(item.product_id + "_" + 0)}/${item.product_id}`}
                    className="card-img-top"
                    alt={item.product_name}
                    style={{ width: '100px', height: '100px', objectFit: 'cover', background: "var(--sectionAlternate)" }}
                    loading='lazy'
                  />
                </picture>
                <FaTrashAlt
                  className="delete-icon"
                  style={{ color: "var(--error)", cursor: "pointer", position: "absolute", top: 10, right: 10 }}
                  onClick={() => onDeleteItem(item.cart_id)}
                />
                <div className="card-body d-flex justify-content-between align-items-center flex-fill">
                  <div className="w-50">
                    <h5 className="card-title" style={{ color: "var(--textHeading)" }}>{item.product_name}</h5>
                    <p className="card-text" style={{ color: "var(--primary)" }}>${item.price.toFixed(2)}</p>
                    <div className="input-group">
                      <button
                        className="btn btn-outline-secondary"
                        style={{ borderColor: "var(--primary)", color: "var(--primary)" }}
                        onClick={() => onUpdateQuantity(item.cart_id, item.quantity - 1)}
                      >
                        -
                      </button>
                      <input
                        type="number"
                        className="form-control text-center"
                        value={item.quantity}
                        onChange={(e) => {
                          const value = parseInt(e.target.value);
                          if (value > 0) {
                            onUpdateQuantity(item.cart_id, value);
                          }
                        }}
                        min="1"
                        style={{
                          background: "var(--cardBackground)",
                          color: "var(--textMain)",
                          borderColor: "var(--dividerLine)"
                        }}
                      />
                      <button
                        className="btn btn-outline-secondary"
                        style={{ borderColor: "var(--primary)", color: "var(--primary)" }}
                        onClick={() => onUpdateQuantity(item.cart_id, item.quantity + 1)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div>
                    <h5 className="card-title" style={{ color: "var(--primary)" }}>${(item.price * item.quantity).toFixed(2)}</h5>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>Your cart is empty.</p>
        )}

        {cartItem && cartItem.length > 0 && (
          <div className="mt-4"
            style={{
              background: "var(--cardBackground)",
              color: "var(--textMain)",
              border: `1px solid var(--cardBorder)`,
              borderRadius: 8,
              padding: 24
            }}
          >
            <h3 style={{ color: "var(--textHeading)" }}>Cart Total</h3>
            <p style={{ color: "var(--primary)" }}>Subtotal: ${subtotal.toFixed(2)}</p>
            <h4 style={{ color: "var(--primary)" }}>Total: ${subtotal.toFixed(2)}</h4>
            <button
              className="btn btn-primary btn-lg mt-3"
              style={{
                background: "var(--primary)",
                color: "var(--background)",
                border: "none"
              }}
              onClick={() => navigate('/checkout')}
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
